module.exports = __webpack_public_path__ + "img/rac_logo@2x.2fea206b.png";